import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BootScreen } from "@/components/ProtectedRoute";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setSession, setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sid });
        const u = setSession(data);
        const next = localStorage.getItem("aurora_next");
        localStorage.removeItem("aurora_next");
        nav(u.role === "admin" ? "/admin" : next || "/dashboard", { replace: true });
      } catch (e) {
        toast.error(errMsg(e));
        setUser(false);
        nav("/", { replace: true });
      }
    })();
  }, [location.hash, nav, setSession, setUser]);

  return <BootScreen label="VERIFYING GOOGLE IDENTITY" />;
}
